// extracted by mini-css-extract-plugin
module.exports = {"peopleAndSize":"PeopleAndSize--peopleAndSize--u4-j1","seating":"PeopleAndSize--seating--2YcxG","size":"PeopleAndSize--size--UbhYX"};